import { Component, Input, OnInit } from '@angular/core';
import { NavParams, PopoverController, ToastController, ViewController, ModalController } from 'ionic-angular';
import { Rodeo } from '../../model/rodeo';
import { CheckFormat, CheckFormatContainer } from '../../model/check-format.model';
import { Organization } from '../../model/organization';
import { LocalStorageService } from '../../services/local-storage';
import { OrganizationService } from '../../services/organization.service';
import { PaymentService } from '../../services/payment.service';
import { CheckStylePopover } from './check-style-popover.component';
import { OrganizationCheckRegister } from 'model/organizationCheckRegister';
import { OrganizationCheckRegisterService } from '../../services/organization-check-service';
import { AlertMessager } from '../../lib/alertMessager';

@Component({
    selector: 'app-print-checks',
    templateUrl: 'print-checks.component.html'
})
export class PrintChecksComponent implements OnInit {
    hideBackground = false;
    @Input() checksToPrint: OrganizationCheckRegister[];
    @Input() rodeo: Rodeo;
    checks = [];
    checkFormats: CheckFormatContainer[];
    selectedFormat: CheckFormatContainer;
    styles: CheckFormat;
    selectedStyles: any;
    selectedStyleName: string;
    isPopoverOpen = false;
    userOrganizations: Organization[] = [];
    filteredChecks: OrganizationCheckRegister[] = [];
    searchQuery: string = '';
    matchString: string = '';
    startingCheckNum: number;
    additionalMemo: string = '';
    addToCheckRegister: boolean;
    currentUserId: number;

    private ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    private tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    private teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];

    constructor(
        private paymentService: PaymentService,
        private organizationService: OrganizationService,
        private storageService: LocalStorageService,
        private toast: ToastController,
        private popover: PopoverController,
        public viewCtrl: ViewController,
        public modalCtrl: ModalController,
        private params: NavParams,
        private organizationCheckService: OrganizationCheckRegisterService,
        private alertMessager: AlertMessager
    ) { }

    ngOnInit() {
        this.addToCheckRegister = this.params.get('addToCheckRegister');
        this.startingCheckNum = this.params.get('startingCheckNum');
        this.checksToPrint = this.params.get('checksToPrint');
        this.rodeo = this.params.get('rodeo');

        if (this.addToCheckRegister == undefined)
            this.addToCheckRegister = true;

        this.filterChecks();

        this.getPrintStyles().then(() => { });

        if (this.rodeo && this.rodeo.organizationCheckRegister && this.rodeo.organizationCheckRegister.length > 0 && this.startingCheckNum == undefined) {
            this.startingCheckNum = +this.rodeo.organizationCheckRegister[this.rodeo.organizationCheckRegister.length - 1].checkNumber + 1;
        }

        this.storageService.getEntity('authtokens')
            .then((token: any) => {
                const isAdmin = token.roles.map(x => x.roleId).includes(6);
                const orgIds = token.roles.map(x => x.organizationId) as number[];
                this.currentUserId = token.id;
                console.log({ token, orgIds, isAdmin });
                this.organizationService.getOrganizations()
                    .then((orgs: Organization[]) => {
                        this.userOrganizations = isAdmin ? orgs : orgs.filter(x => orgIds.includes(x.id));
                    });
            });
    }

    createChecks() {
        this.checks = [];

        const checksArray = this.filteredChecks;

        if (checksArray && checksArray.length > 0) {
            if (this.styles) {
                if (this.styles.check.combinePayouts) {
                    const payoutsHash = {};
                    //create payoutHash
                    checksArray.forEach(check => {
                        if (check.name) {
                            if (payoutsHash[check.name]) {
                                payoutsHash[check.name].push(check);
                            } else {
                                payoutsHash[check.name] = [check];
                            }
                        }
                    });

                    //create check
                    let page = [];
                    Object.keys(payoutsHash).forEach(name => {
                        const userPayouts = payoutsHash[name];
                        const payoutAmount = userPayouts.length > 1 ? userPayouts.map(x => x.amount).reduce((a, b) => +a + +b) : userPayouts[0].amount;
                        const memos = userPayouts.map(x => x.memo);

                        let check = this.formatCheck(userPayouts[0], payoutAmount, memos.join(', ').substring(0, 150));

                        if (this.styles.check.checkLayout == '3') {
                            //three copies of each checks 
                            page = [check, check, check];
                        } else if (this.styles.check.checkLayout == '2') {
                            //1 check w/ 2 receipts
                            const receipt = Object.assign({}, check) as any;
                            receipt.isReceipt = true;
                            receipt.payouts = [userPayouts[0]];
                            page = [check, receipt, receipt]
                        } else {
                            //single checks
                            page.push(check);
                        }

                        const isLastPage = this.checks.length * 3 + page.length == checksArray.length;
                        if (page.length == 3 || isLastPage) {
                            this.checks.push(page);
                            page = [];
                        }
                    });

                    //sort by memo to keep everything in a similar order 
                    this.checks = this.checks.sort((a, b) => a[0].memo > b[0].memo ? 1 : -1);
                } else {
                    let page = [];
                    checksArray.forEach(x => {
                        if (this.styles && this.styles.check.checkLayout == '3') {
                            page = [
                                this.formatCheck(x, x.amount, x.memo),
                                this.formatCheck(x, x.amount, x.memo),
                                this.formatCheck(x, x.amount, x.memo)
                            ];
                        } else if (this.styles.check.checkLayout == '2') {                         //1 check w/ 2 receipts
                            const receipt = Object.assign({}, this.formatCheck(x, x.amount, x.memo)) as any;
                            receipt.isReceipt = true;
                            receipt.payouts = [x];
                            page = [this.formatCheck(x, x.amount, x.memo), receipt, receipt];
                        } else {
                            page.push(this.formatCheck(x, x.amount, x.memo));
                        }

                        const isLastPage = this.checks.length * 3 + page.length == checksArray.length;
                        if (page.length == 3 || isLastPage) {
                            this.checks.push(page);
                            page = [];
                        }
                    });
                }
            }
        }
    }

    private formatCheck(payout, amount, memo) {
        return {
            amount,
            memo: memo + ' ' + this.additionalMemo,
            date: new Date().toLocaleDateString(),
            amountText: this.convert(amount),
            payto: payout.name,
            payouts: [payout]
        };
    }

    filterChecks() {
        const lowerCaseQuery = this.searchQuery.trim().toLowerCase();

        this.filteredChecks = this.checksToPrint.filter((check) =>
            check.name
                .trim()
                .toLowerCase()
                .includes(lowerCaseQuery));

        this.matchString = `${this.filteredChecks.length} check${this.filteredChecks.length == 1 ? '' : 's'} selected.`;

        this.createChecks();
    }

    async getPrintStyles() {
        try {
            const styles = await this.paymentService.getPrintCheckStyles();

            // Only display format options that are 'public' (accountId: 0) or 'private' (accountId: currentUserId) ... 
            // So if multiple secretaries, hides other secretary information
            this.checkFormats = styles.filter(x => x.organizationId === this.rodeo.organization.id && (x.accountId === 0 || x.accountId === this.currentUserId));
            if (!this.selectedFormat) {
                if (styles.filter(x => x.organizationId == this.rodeo.organization.id).length > 0)
                    this.selectedFormat = styles.filter(x => x.organizationId == this.rodeo.organization.id)[0];
                else
                    this.selectedFormat = styles[0];

                this.styles = JSON.parse(this.selectedFormat.stylesJson);

                if (!this.styles.check.bank) {
                    this.styles.check.bank = {
                        routing: '000000000',
                        account: '123456789012',
                        startingCheckNum: this.startingCheckNum ? this.startingCheckNum : 1000
                    };
                } else {
                    this.styles.check.bank.startingCheckNum = this.startingCheckNum ? this.startingCheckNum : 1000;
                }

                if (!this.styles.check.address) {
                    this.styles.check.address = {
                        name: 'Organization Name',
                        address1: '123 Main St',
                        city: 'Austin',
                        state: 'TX',
                        zip: '12345'
                    }
                }

                if (!this.styles.check.currencySymbol) {
                    this.styles.check.currencySymbol = 'USD';
                }
            } else {
                this.selectedFormat = this.checkFormats.find(x => x.displayName == this.selectedFormat.displayName);
            }
        } catch (err) {
            console.warn(err);
        }

        this.createChecks();
    }

    async saveFormat(wasPrompted = false) {
        const format = this.styles;
        const name = this.selectedFormat.displayName;
        const orgId = this.selectedFormat.organizationId;

        if (this.selectedFormat && !wasPrompted) {
            //this is a default style, so any changes will become a new organization preset.
            //user needs to select displayname & org
            const popover = this.popover.create(CheckStylePopover, {
                selectedFormat: this.selectedFormat
            });

            popover.present();
            // console.log({name});
            popover.onDidDismiss((data) => {
                if (data) {
                    if (data.displayName != name || orgId == null) {
                        //save new format
                        this.selectedFormat.id = 0;
                    } //else update

                    if (!data.currencySymbol) {
                        data.currencySymbol = 'USD';
                    }

                    this.saveFormat(true);
                    return;
                }
            });

            this.isPopoverOpen = true;
            return;

        } else {
            if (wasPrompted) {
                this.isPopoverOpen = false;
            }

            //update existing
            this.selectedFormat.stylesJson = JSON.stringify(format);
        }

        try {
            console.log(this.selectedFormat);
            await this.paymentService.savePrintCheckStyle(this.selectedFormat);
            this.toast.create({
                message: 'Format settings saved!',
                duration: 2500
            }).present()
        } catch (err) {
            this.toast.create({
                message: 'Could not save settings. Try again later.',
                duration: 2500
            }).present();
        }

        await this.getPrintStyles();
    }

    async deleteFormat() {
        if (this.selectedFormat.organizationId && this.selectedFormat.id) {
            try {
                await this.paymentService.deletePrintCheckStyle(this.selectedFormat.id);
                this.toast.create({
                    message: 'Format settings deleted',
                    duration: 2500
                }).present();
            } catch (err) {
                this.toast.create({
                    message: 'Could not delete format settings.',
                    duration: 2500
                }).present();
            }
        } else {
            this.toast.create({
                message: 'Cannot delete default settings.',
                duration: 2000
            }).present();
        }
    }

    selectCheckFormat(e: any) {
        this.selectedFormat = e as CheckFormatContainer;
        if (this.selectedFormat) {
            this.styles = JSON.parse(this.selectedFormat.stylesJson);
        }

        if (!this.styles.check.bank) {
            this.styles.check.bank = {
                routing: '000000000',
                account: '123456789012',
                startingCheckNum: this.startingCheckNum ? this.startingCheckNum : 1000
            };
        } else {
            this.styles.check.bank.startingCheckNum = this.startingCheckNum ? this.startingCheckNum : 1000;
        }

        if (!this.styles.check.address) {
            this.styles.check.address = {
                name: 'Organization Name',
                address1: '123 Main St',
                city: 'Austin',
                state: 'TX',
                zip: '12345'
            }
        }

        if (!this.styles.check.currencySymbol) {
            this.styles.check.currencySymbol = 'USD';
        }

        this.createChecks();
    }

    print(targetId: string) {
        this.hideBackground = true;
        setTimeout(() => {
            new Promise((resolve, reject) => {
                //get target html
                const printContent = document.getElementById(targetId);
                //create window
                const WindowPrt = window.open('', '', 'left=0,top=0,width=900,height=600,toolbar=0,scrollbars=0,status=0');
                if (WindowPrt && printContent) {
                    //create html
                    let html = '<html><head>';

                    html += `<style type="text/css"> 
          @font-face {
            font-family: "MICR";
            src: url("/assets/fonts/micrenc.ttf") format("truetype");
          }
          
          @media print {
            @page {
              margin: .2in .2in 0;
            }
          }
          </style>`;

                    html += `</head><body style="margin: 0;"><div id="${targetId}">${printContent.innerHTML}</div></body>`;
                    html += '</html>';
                    //write html to window
                    WindowPrt.document.write(html);
                    WindowPrt.document.close();
                    //open window
                    setTimeout(() => {
                        WindowPrt.focus();
                        WindowPrt.print();

                        if (this.addToCheckRegister) {
                            this.alertMessager.prompt("Check Register", "Do you want to add those checks to the check register?", () => {this.saveCheckInformation()});
                        }

                        WindowPrt.close();
                        
                        resolve(true);
                    }, 1000);
                }
            }).then(() => this.hideBackground = false);
        }, 100);
    }

    async saveCheckInformation() {
        try {
            let checks = [];
            this.checks.forEach((x, index) => checks.push(this.convertCheckFormatToOrganizationCheckRegister(x[0], index)));
            checks = await this.organizationCheckService.CreateOrganizationCheckRegisters(checks);
            this.rodeo.organizationCheckRegister.push(...checks);
        } catch (error) {
            this.toast.create({
                message: 'An error occurred.',
                duration: 2500
            }).present();

            console.log('An error occurred.: ', error);
        }
    }

    convertCheckFormatToOrganizationCheckRegister(check: any, addToStartCheckNumber: number): OrganizationCheckRegister {
        return {
            id: 0,
            organizationId: this.rodeo.organization.id,
            rodeoId: this.rodeo.id,
            name: (check && check.payto) || '',
            memo: check.memo,
            streetAddress: (check && check.payouts[0] && check.payouts[0].streetAddress || ''),
            city: (check && check.payouts[0] && check.payouts[0].city) || '',
            state: (check && check.payouts[0] && check.payouts[0].state) || '',
            zipcode: (check && check.payouts[0] && check.payouts[0].zipcode) || '',
            checkNumber: this.styles.check.bank.startingCheckNum !== undefined ? (this.styles.check.bank.startingCheckNum * 1 + addToStartCheckNumber * 1).toString() : '',
            amount: check.amount,
            datePrinted: new Date().toLocaleString(),
            voided: false
        };
    }

    editPosition($event: any, selectedStyleName: string) {
        if (!$event) return;
        $event.preventDefault();
        $event.stopPropagation();
        this.selectedStyleName = selectedStyleName;
        this.selectedStyles = this.styles[selectedStyleName];

        this.popover.create(CheckStylePopover, {
            selectedStyles: this.selectedStyles
        }).present({ ev: $event });
    }

    close() {
        this.viewCtrl.dismiss();
    }

    convertToNumber(event) {
        this.styles.check.bank.startingCheckNum = event ? Number(event.value) : 0;
    }

    private convert_millions(num) {
        if (num >= 1000000) {
            return this.convert_millions(Math.floor(num / 1000000)) + " million " + this.convert_thousands(num % 1000000);
        } else {
            return this.convert_thousands(num);
        }
    }

    private convert_thousands(num) {
        if (num >= 1000) {
            return this.convert_hundreds(Math.floor(num / 1000)) + " thousand " + this.convert_hundreds(num % 1000);
        } else {
            return this.convert_hundreds(num);
        }
    }

    private convert_hundreds(num) {
        if (num > 99) {
            return this.ones[Math.floor(num / 100)] + " hundred " + this.convert_tens(num % 100);
        } else {
            return this.convert_tens(num);
        }
    }

    private convert_tens(num) {
        const wholeNum = Math.floor(num);
        const decimal = Math.round((num - wholeNum) * 100);
        const decimalSuffix = decimal > 0 ? ' and ' + decimal + '/100' : null;
        if (num < 10) return this.ones[wholeNum] + (decimalSuffix || '');
        else if (num >= 10 && num < 20) return this.teens[wholeNum - 10] + (decimalSuffix || '');
        else {
            return this.tens[Math.floor(wholeNum / 10)] + " " + this.ones[wholeNum % 10] + (decimalSuffix || '');
        }
    }

    private convert(num) {
        if (!num) debugger;
        if (num == 0) return "zero";
        else return this.convert_millions(num);
    }
}



// WEBPACK FOOTER //
// ./src/pages/print-checks/print-checks.component.ts